// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ct-logo-icon-dark[data-v-54c71bc5]{display:block}.ct-logo-icon-light[data-v-54c71bc5]{display:none}@media(max-width:768px){.ct-logo-icon-dark[data-v-54c71bc5],.ct-logo-icon-light[data-v-54c71bc5]{transform:scale(.7);transform-origin:left}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
